<template>
  <div class="header-wrapper" :class="{ 'show-shadow': showHeaderShadow }">
    <!--START: Page Header-->
    <div class="regular-header">
      <h3 v-if="content.title != undefined" v-html="content.title"></h3>
      <p v-if="content.description != undefined">{{ content.description }}</p>
    </div>
    <!--END: Page Header-->
    <button
      v-if="showButton"
      class="btn btn-small btn-primary"
      :disabled="disableButton"
      @click="buttonClicked"
    >
      {{ buttonTitle }}
    </button>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    content: Object,
    disableButton: Boolean,
    showButton: { type: Boolean, default: true },
    showHeaderShadow: Boolean,
    buttonTitle: { type: String, default: "Save" },
  },
  methods: {
    async buttonClicked() {
      this.$emit("buttonClicked");
    },
  },
};
</script>

<style scoped lang="scss">
.header-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-bottom: 1.5rem;
  margin-bottom: 0 !important;
  border-bottom: 1px solid lighten($lightGreyColor, 25%);

  .regular-header {
    flex: 1;
    margin-right: 20%;
  }

  .buttons-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  h3 {
    font-size: $mediumFontSize;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: $smallFontSize;
    opacity: $mediumOpacity;
  }
}
</style>
